<template>
  <search-layout class="identity-collect" header="身份验证">
    <page-status :loading="loading">
      <div class="auth-content">
        <div class="auth-title">我们将发送验证码到你的手机号</div>
        <div class="auth-mobile">
          {{ displayMobile }}
        </div>
        <div class="verify-code">
          <van-password-input
            :gutter="16"
            :mask="false"
            :length="smsMaxLength"
            :value="code"
            :focused="focused"
          />
          <input
            class="input-code"
            type="text"
            :maxlength="6"
            v-model="code"
            @focus="focused = true"
            @blur="focused = false"
          />
        </div>
        <div v-if="canSend" class="send-code active" @click="handleSend()">
          发送验证码
        </div>
        <div v-else class="send-code">
          <van-count-down
            ref="countDown"
            :time="smsSecond"
            format="ss"
            @finish="handleFinish()"
          />
          <span>秒后重新发送</span>
        </div>
      </div>
    </page-status>
  </search-layout>
</template>

<script>
import { Toast } from 'vant';
import SearchLayout from '@/layouts/SearchLayout';
import PageStatus from '@/components/PageStatus';
import * as services from '@/services';

export default {
  components: {
    SearchLayout,
    PageStatus,
  },

  computed: {
    displayMobile() {
      const m = this.mobile;
      if (m.includes('*')) {
        return m;
      }
      return m.slice(0, 3) + '****' + m.slice(7, 13);
    },
  },

  data() {
    return {
      loading: true,
      mobile: '',
      smsSecond: 120000,
      canSend: true,
      focused: false,
      code: '',
      smsMaxLength: 6,
      prevCodeLength: 0,
    };
  },

  created() {
    const token =
      this.$route.query.authToken || window.localStorage.getItem('authToken');
    window.localStorage.setItem('authToken', token);
    this.fetchData();
  },

  methods: {
    fetchData() {
      const { maskMobile } = this.$route.query;
      this.mobile = decodeURIComponent(maskMobile || '');
      this.loading = false;
    },

    handleSend() {
      this.sendAuthSms();
    },

    handleFinish() {
      this.canSend = true;
    },

    sendAuthSms() {
      Toast.loading({
        message: '正在发送',
        forbidClick: true,
        duration: 0,
      });

      const { businessNo, mobile } = this.$route.query;
      services
        .sendIdentityVCode(businessNo, mobile)
        .then(res => {
          if (res) {
            const { failCause } = res;
            if (failCause) {
              Toast({ message: failCause, duration: 3000 });
            } else {
              this.canSend = false;
              Toast.success('发送成功');
            }
          }
        })
        .catch(() => {
          Toast({ message: '发送失败，请重试', duration: 3000 });
        });
    },

    checkAuthSms() {
      Toast.loading({
        message: '正在验证',
        forbidClick: true,
        duration: 0,
      });

      const codeNo = this.code;
      const { businessNo, mobile } = this.$route.query;

      services
        .confirmIdentityVCode(businessNo, mobile, codeNo)
        .then(res => {
          const { failCause } = res;
          if (failCause) {
            Toast({ message: failCause, duration: 3000 });
          } else {
            Toast.clear();
            const { businessNo, code } = this.$route.query;
            services
              .eproposalShift(businessNo)
              .then(res => {
                const { content } = res;
                if (content) {
                  const newUrl = code ? `${content}&code=${code}` : content;
                  window.location.replace(newUrl);
                }
              })
              .finally(() => {
                this.loading = false;
              });
          }
        })
        .catch(() => {
          Toast({ message: '验证失败，请重试', duration: 3000 });
        });
    },
  },

  watch: {
    code(value) {
      const sanitized = value
        .slice(0, this.smsMaxLength)
        .replace(/[^A-Za-z0-9]/g, '')
        .toUpperCase();
      // 只有 sanitization 真正改变了值时才重新赋值，避免 watcher 死循环
      if (sanitized !== this.code) {
        this.code = sanitized;
        return;
      }
      // 只在长度从 < max 变到 === max 时触发，避免多次输入时重复调用
      const len = this.code.length;
      if (
        len === this.smsMaxLength &&
        this.prevCodeLength < this.smsMaxLength
      ) {
        this.checkAuthSms();
      }
      this.prevCodeLength = len;
    },
  },
};
</script>

<style lang="less">
.identity-collect {
  .header {
    font-size: 24px;
  }
  .auth-content {
    padding: 24px 12px;
    text-align: center;

    .auth-title {
      color: #9b9b9b;
    }

    .auth-mobile {
      margin-top: 12px;
      color: #4a4a4a;
      font-size: 24px;
    }

    .verify-code {
      margin-top: 24px;
      position: relative;

      .van-password-input {
        li {
          border-radius: 4px;
          border: 1px solid #dcdcdc;
        }
      }

      .input-code {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        border: 0;
        outline: none;
        opacity: 0;
      }
    }

    .send-code {
      margin-top: 12px;
      padding: 12px 0;
      color: #9b9b9b;
      font-size: 16px;

      .van-count-down {
        display: inline-block;
        font-size: 16px;
      }

      &.active {
        background-image: linear-gradient(136deg, #3a91ec 0%, #426ed9 100%);
        box-shadow: 0rpx 16rpx 30rpx -20rpx #4677d9;
        width: 320px;
        height: 24px;
        margin: 48px auto;
        border-radius: 4px;
        color: #fff;
      }
    }
  }
}
</style>
